import styled from 'styled-components'
import { CardContent as MuiCardContent } from '@material-ui/core'

export const CardContent = styled(MuiCardContent)`
  flex: 1;
  padding: 0;
  display: flex;
  flex-direction: column;
  &:last-child {
    padding-bottom: 0;
  }
`
